var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useRef, useState } from 'react';
import { Model } from './Model';
import isEqual from 'fast-deep-equal';
var isAsyncModel = function (model) {
    return (typeof model.getMetaAsObservable === 'function' &&
        typeof model.getMeta === 'function');
};
export function useModel(model) {
    var unmountRef = useRef(false);
    var _a = useState(model.getValue()), value = _a[0], setValue = _a[1];
    var _b = useState(isAsyncModel(model)
        ? model.getMeta()
        : {
            loading: false,
            done: true,
            error: null
        }), meta = _b[0], setMeta = _b[1];
    var sub = useState({ current: null })[0];
    if (!sub.current) {
        sub.current = model.asObservable().subscribe(function (value) {
            if (!unmountRef.current) {
                setValue(value);
            }
        });
        if (isAsyncModel(model)) {
            sub.current.add(model.getMetaAsObservable().subscribe(function (meta) {
                if (!unmountRef.current) {
                    setMeta(__assign({}, meta));
                }
            }));
        }
    }
    useEffect(function () {
        return function () {
            var _a;
            unmountRef.current = true;
            (_a = sub.current) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        };
    }, []);
    return { value: value, meta: meta };
}
export function useModelField(model, fieldKey) {
    var _a = useState(model.getValue()[fieldKey]), value = _a[0], setValue = _a[1];
    var _b = useState(isAsyncModel(model)
        ? model.getMeta()
        : {
            loading: false,
            done: true,
            error: null
        }), meta = _b[0], setMeta = _b[1];
    var sub = useState({ current: null })[0];
    if (!sub.current) {
        sub.current = model.fieldChanges(fieldKey).subscribe(function (value) {
            setValue(value.value);
        });
        if (isAsyncModel(model)) {
            sub.current.add(model.getMetaAsObservable().subscribe(function (meta) {
                setMeta(__assign({}, meta));
            }));
        }
    }
    useEffect(function () {
        return function () {
            var _a;
            (_a = sub.current) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        };
    }, []);
    return {
        value: value,
        meta: meta
    };
}
export function useModelBuilder(initialValue, deps, options) {
    if (deps === void 0) { deps = []; }
    if (options === void 0) { options = {}; }
    var depsRef = useRef(deps);
    var modelRef = useRef(null);
    if (!modelRef.current) {
        modelRef.current = new Model(initialValue);
    }
    useEffect(function () {
        var _a;
        if (!((options === null || options === void 0 ? void 0 : options.comparator) || isEqual)(depsRef.current, deps)) {
            depsRef.current = deps;
            (_a = modelRef.current) === null || _a === void 0 ? void 0 : _a.setValue(initialValue);
            return;
        }
    });
    useEffect(function () {
        return function () {
            var _a;
            (_a = modelRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
        };
    }, []);
    return modelRef.current;
}
//# sourceMappingURL=hooks.js.map